import { CContainer, CInput, CLabel } from '@coreui/react';
import * as React from 'react';
import { Redirect } from 'react-router';
import { AppLabels } from '../core/AppLabels';
import { Utils } from '../core/utils';
import { securitySvc } from '../Karma';

interface IProps {
}

interface IState {
	redirectUrl: string;
	mdp: string;
}

export class Authentication extends React.Component<IProps, IState> {
	static URL: string = "/Authentication";

	public constructor(props: any) {
		super(props);

		this.state = {
			redirectUrl: "",
			mdp: "",
		};
	}

	onchange = (event: any) => {
		this.setState({ mdp: event.target.value });
		this.forceUpdate();
	}

	//#region Rendering 
	renderQRCode = () => {
		if (!this.state.mdp) return null;

		var QRCode = require('qrcode.react');
		var generated = "AUTH:" + btoa(Utils.stringToHex(securitySvc.currentUser.login + ":" + this.state.mdp)) + ":AUTH";

		return (<CContainer>
			<div className="Authentication">
				<CLabel>{AppLabels.authenticationLoginSummary}{securitySvc.currentUser.login}</CLabel>
				<QRCode value={generated} />
				<CLabel>{generated}</CLabel>
			</div>
		</CContainer>)
	}

	render() {
		if (!securitySvc.isAuth()) return <Redirect to="/"></Redirect>
		if (this.state.redirectUrl) return <Redirect to={this.state.redirectUrl} ></Redirect>
		let qr = this.renderQRCode();

		return (
			<div>

				<CContainer>
					<CLabel  >{AppLabels.enterPassword}</CLabel>
					<CInput type="password" name="_pwd" key="pwd" onChange={this.onchange} ></CInput>
				</CContainer>
				{qr}
			</div>
		);
	}
	//#endregion 
}
